import { mapGetters } from 'vuex'

const SIZE_TYPE = {
  AUTO: 'AUTO',
  FIXED: 'FIXED',
  SCREEN_PERCENTAGE: 'SCREEN_PERCENTAGE'
}

export default {
  props: {
    size: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      SIZE_TYPE
    }
  },
  computed: {
    ...mapGetters('microSite', ['isEditMode', 'isMobile']),
    wrapperStyle () {
      return {
        width: this.width,
        height: this.height
      }
    },
    width () {
      let width
      const config = this.size?.width
      const type = config?.type
      if (type === SIZE_TYPE.FIXED) {
        width = `${config.fixed}`
        if (!width.includes('px')) {
          width += 'px'
        }
      } else if (type === SIZE_TYPE.SCREEN_PERCENTAGE) {
        width = `${config.percentage}%`
      } else {
        // type === SIZE_TYPE.AUTO
        // will display with 100 vw in css style
      }
      return width
    },
    height () {
      let height
      const config = this.size?.height
      const type = config?.type
      if (type === SIZE_TYPE.FIXED) {
        height = `${config.fixed}`
        if (!height.includes('px')) {
          height += 'px'
        }
      } else if (type === SIZE_TYPE.SCREEN_PERCENTAGE) {
        height = `${config.percentage}vh`
      } else {
        // type === SIZE_TYPE.AUTO
        // unset, will auto use module's content height
      }
      return height
    }
  }
}

export {
  SIZE_TYPE
}
